import { RootState } from '@app/redux/root-reducer';

export const selectProductsState = (store: RootState) => store.productSlice.products;
export const selectProductDetailState = (store: RootState) => store.productSlice.productDetail;
export const selectAddProductState = (store: RootState) => store.productSlice.addProduct;
export const selectGenrateLinkState = (store: RootState) => store.productSlice.generateLink;
